import ApiService from '../services/apiService.js';

var api = new ApiService();

const setAgencyUser = ({ commit }, params) => {
  commit('setAgencyUser', params);
};

const setAgencyUsers = ({ commit }, params) => {
  commit('setAgencyUsers', params);
};

const setInsureSignUsers = ({ commit }, params) => {
  commit('setInsureSignUsers', params);
};

const setProductTrial = ({ commit }, params) => {
  commit('setProductTrial', params);
};

const setDataSharingOptIn = ({ commit }, params) => {
  commit('setDataSharingOptIn', params);
};

const setAgency = ({ commit }, params) => {
  commit('setAgency', params);
};

const setSelectedInsureSignUsers = ({ commit }, params) => {
  commit('setSelectedInsureSignUsers', params);
};

const setRegistration = ({ commit }, params) => {
  commit('setRegistration', params);
};

const setError = ({ commit }, params) => {
  commit('setError', params);
};

const resetError = ({ commit }) => {
  commit('resetError');
};

const setSeatChangeDeletionError = ({ commit }, params) => {
  commit('setSeatChangeDeletionError', params);
};

const setSeatChangeDeletionSuccess = ({ commit }, params) => {
  commit('setSeatChangeDeletionSuccess', params);
};

const resetSeatChangeDeletionSuccessState = ({ commit }) => {
  commit('resetSeatChangeDeletionSuccessState');
};

const setPendingSeatManagementRequests = ({ commit }, params) => {
  commit('setPendingSeatManagementRequests', params);
};

const updatePendingSeatManagementRequest = ({ commit }, params) => {
  commit('updatePendingSeatManagementRequest', params);
};

const deletePendingSeatManagementRequest = ({ commit }, params) => {
  if (params.action === 'remove') {
    commit('setRemoteAgencySeatDisplay', params.seat);
  }
  commit('deletePendingSeatManagementRequest', params.id);
};

const setRemoteAgencySeats = ({ commit }, params) => {
  commit('setRemoteAgencySeats', params);
};

const setRemoteAgencySeatDisplay = ({ commit }, params) => {
  commit('setRemoteAgencySeatDisplay', params);
};

const addRemoteAgencySeat = ({ commit }, params) => {
  commit('addRemoteAgencySeat', params);
};

const addPendingSeatManagementRequest = ({ commit }, params) => {
  commit('addPendingSeatManagementRequest', params);
};

const getAgencyVersion = async ({ commit }) => {
  var res = await api.getAgencyVersion();
  if (res.status === 200 && res.data !== null) {
    commit('setAgencyVersion', res.data);
  }
};

const getProducts = async ({ commit, state }, forceReload) => {
  // state.products should never be null. Starts as []
  if (state.products.length > 0 && !forceReload) {
    return Promise.resolve({ code: 0 }); // Ya we loaded boi
  }
  let p = api.getProducts();
  let rs = await p;
  if (rs.code === 0) {
    commit('setProducts', JSON.parse(rs.data[0]));
  }
  return p;
};

// What even is this?
// TODO refactor all callers to call newSetProductSubscription action instead, then delete this.
const setProductSubscription = ({ commit }, params) => {
  commit('setProductSubscription', params);
};

const newSetProductSubscription = async (
  { commit },
  { productId, subscription, feedback = null, sendEmail = false }
) => {
  let p = api.setSubscriptionDetailed(productId, subscription, feedback, sendEmail);
  let rs = await p;
  if (rs.code === 0) {
    // Succeeded, update store
    commit('setProductSubscription', { productId: productId, subscription: subscription });
  }
  return p;
};

const getFeatureSwitches = async ({ commit, state }, forceReload = false) => {
  if (state.featureSwitches !== null && !forceReload) {
    return;
  }
  var res = await api.getFeatureSwitches();
  if (res.status === 200 && res.data.code === 0) {
    commit('setFeatureSwitches', res.data.data[0]);
  }
};

export default {
  setAgencyUser,
  setAgencyUsers,
  setInsureSignUsers,
  setProductSubscription,
  setProductTrial,
  setDataSharingOptIn,
  setAgency,
  setSelectedInsureSignUsers,
  setRegistration,
  resetError,
  setError,
  setSeatChangeDeletionError,
  setSeatChangeDeletionSuccess,
  resetSeatChangeDeletionSuccessState,
  setPendingSeatManagementRequests,
  updatePendingSeatManagementRequest,
  deletePendingSeatManagementRequest,
  setRemoteAgencySeats,
  setRemoteAgencySeatDisplay,
  addRemoteAgencySeat,
  addPendingSeatManagementRequest,
  getFeatureSwitches,
  getAgencyVersion,
  getProducts,
  newSetProductSubscription
};
